<template>
	<div class="menu-sap">
		<div class="menu-sap__toggle" @click="onToggleClick">
			<div class="menu-sap__toggle-left">
				<b-form-checkbox v-model="is_sap" @click.native.stop />
				<span class="menu-sap__label">
					{{ documentType === "invoices" ? $t("Facture") : $t("Devis") }}
				</span>
			</div>
			<img :src="require('@/assets/logo-sap.png')" alt="SAP" class="menu-sap__logo" />
		</div>

		<div class="menu-sap__hint">
			<b-icon-question-circle-fill font-scale="1.4" class="menu-sap__hint-icon" />
			<span>{{ documentType === 'invoices' ? $t('is_sap_explanation_invoice') : $t('is_sap_explanation_quote') }}</span>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from "vuex";

	export default {
		name: "MenuSap",
	
		data() {
			return {}
		},
		computed: {
			...mapState({
				appId: state => state.app.id,
				background: state => state.settings.accentColor.background,
				foreground: state => state.settings.accentColor.foreground,
				documentType: state => state.page.type
			}),
			...mapGetters([
				'displayMenuSap'
			]),
			is_sap: {
				get() {
					return !this.displayMenuSap ? false : this.$store.state.home.is_sap;
				},
				set(value) {
					this.$store.commit("is_sap", value);
				}
			}
		},
		mounted() {},
		methods: {
			onToggleClick(e) {
				if (e.target.type === "checkbox") return;
				this.is_sap = !this.is_sap;
			}
		}
	};
</script>

<style lang="scss">
	.menu-sap {
		padding: 4px 0;

		&__toggle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 4px 12px;
			border-radius: 6px;
			border: 1px solid var(--border, #dee2e6);
			cursor: pointer;
			transition: background-color 0.15s ease;

			&:hover {
				background-color: #f5f7fa;
			}
		}

		&__toggle-left {
			display: flex;
			align-items: center;
			gap: 8px;
		}

		&__label {
			font-size: 0.9rem;
			font-weight: 500;
			color: #333;
		}

		&__logo {
			height: 35px;
			width: auto;
			opacity: 0.85;
		}

		&__hint {
			display: flex;
			align-items: flex-start;
			gap: 6px;
			margin-top: 10px;
			padding: 8px 10px;
			background: #f0f4f8;
			border-radius: 6px;
			font-size: 0.78rem;
			color: #6c757d;
			line-height: 1.4;
		}

		&__hint-icon {
			flex-shrink: 0;
			margin-top: 2px;
			font-size: 0.85rem;
			color: #90a4ae;
		}
	}
</style>
